import React from 'react';

interface ThumbsDownFilledIconProps {
  className?: string;
  fill?: string;
}

export default function ThumbsDownFilledIcon({ className, fill = 'currentColor' }: ThumbsDownFilledIconProps) {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M27.8555 18.3984L26.4492 7.14844C26.3612 6.47002 26.03 5.8466 25.517 5.39399C25.0041 4.94137 24.3442 4.69033 23.6602 4.6875H3.75C3.25272 4.6875 2.77581 4.88504 2.42417 5.23667C2.07254 5.58831 1.875 6.06522 1.875 6.5625V16.875C1.875 17.3723 2.07254 17.8492 2.42417 18.2008C2.77581 18.5525 3.25272 18.75 3.75 18.75H8.78906L13.2188 27.6094C13.2995 27.7637 13.4206 27.8932 13.5692 27.984C13.7178 28.0749 13.8883 28.1236 14.0625 28.125C15.3048 28.1219 16.4952 27.6271 17.3736 26.7486C18.2521 25.8702 18.7469 24.6798 18.75 23.4375V21.5625H25.0664C25.4659 21.5642 25.8611 21.4804 26.2256 21.3168C26.59 21.1532 26.9152 20.9135 27.1794 20.6138C27.4436 20.3141 27.6406 19.9614 27.7572 19.5793C27.8738 19.1972 27.9073 18.7946 27.8555 18.3984ZM8.4375 16.875H3.75V6.5625H8.4375V16.875Z"
        fill={fill}
      />
    </svg>
  );
}
